(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[355],{

/***/ 28613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ FiFilter; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FiFilter(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 9838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ HiChevronLeft; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function HiChevronLeft(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fillRule": "evenodd",
        "d": "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
        "clipRule": "evenodd"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 78762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34853);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ReCaptcha = function ReCaptcha(props, ref) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
      ref: ref,
      sitekey: "6LeJZ68UAAAAAJZ8jxdgylEXeWL8P9Ckv7CLtE6t",
      badge: "inline",
      size: "invisible"
    }, props))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(ReCaptcha));

/***/ }),

/***/ 85504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Icon_bs_BsFillCheckCircleFill__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25772);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56507);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var StepBar = function StepBar(_ref) {
  var _data, _data$sub_step, _data$sub_step2;

  var step = _ref.step,
      subStep = _ref.subStep,
      data = _ref.data;
  var width = 100 / (data === null || data === void 0 ? void 0 : data.length);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "hidden items-start lg:flex",
      children: data === null || data === void 0 ? void 0 : data.map(function (item, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
          className: "col flex last:col-auto last:block last:w-[112px]",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "col flex max-w-[112px] flex-col items-center   ",
            children: [step - 1 === index ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
              className: "h-8 w-8  rounded-full bg-bbc-primary pt-1 text-center text-bbc-white",
              children: item.id
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
              children: [" ", step < index + 1 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "h-8 w-8  rounded-full bg-bbc-primary pt-1 text-center text-bbc-white opacity-40",
                children: item.id
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_atoms_Icon_bs_BsFillCheckCircleFill__WEBPACK_IMPORTED_MODULE_0__/* .BsFillCheckCircleFill */ .R, {
                className: "text-3xl text-bbc-primary "
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
              className: "mt-2 text-center text-sm font-medium  ".concat(step == 0 && index == 0 || step - 1 == index ? "text-bbc-primary " : "text-bbc-neutral-600", " "),
              children: item.name
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "".concat((data === null || data === void 0 ? void 0 : data.length) === index + 1 ? "hidden" : "", " col flex items-center"),
            style: {
              height: "30px"
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
              className: " h-0.5 w-full  bg-bbc-primary"
            })
          })]
        }, index);
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "mb-14 flex items-center justify-center lg:mb-20 lg:hidden",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "w-4",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
          className: "h-4 w-4 rounded-full border-4 border-bbc-primary bg-bbc-white"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "flex w-[calc(100%_-_32px)] items-center",
        children: data === null || data === void 0 ? void 0 : data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            style: {
              width: "".concat(width, "%")
            },
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
              className: " w-full ",
              children: step == 0 && index == 0 || step - 1 == index ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "h-2 w-full bg-bbc-primary "
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: step < index + 1 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                  className: "h-2 w-full bg-bbc-neutral-600  pt-1 text-center text-bbc-white "
                }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                  className: "h-2  w-full bg-bbc-primary  pt-1 text-center text-bbc-white "
                })
              })
            }), step == 0 && index == 0 || step - 1 == index ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
              className: "col-12 absolute left-0 right-0 mt-3 ml-auto  mr-auto text-center text-sm font-medium  text-bbc-primary",
              children: item.name
            }) : null]
          }, index);
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "w-4",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
          className: "h-4 w-4 rounded-full border-4 border-bbc-primary bg-bbc-primary"
        })
      })]
    }), ((_data = data[step - 1]) === null || _data === void 0 ? void 0 : (_data$sub_step = _data.sub_step) === null || _data$sub_step === void 0 ? void 0 : _data$sub_step.length) > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "relative my-10 flex  items-center justify-center ",
      children: (_data$sub_step2 = data[step - 1].sub_step) === null || _data$sub_step2 === void 0 ? void 0 : _data$sub_step2.map(function (item, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
          className: "flex w-[80px] items-center last:w-4",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: " ",
            children: subStep - 1 === index ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
              className: "h-4 w-4 rounded-full border-4 border-bbc-primary bg-bbc-white"
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
              className: "h-4 w-4 rounded-full border-4 border-bbc-primary bg-bbc-primary"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "".concat((data === null || data === void 0 ? void 0 : data.length) === index + 1 ? "hidden" : "", " col flex items-center  "),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
              className: " h-1 w-full bg-bbc-primary"
            })
          }), subStep == 0 && index == 0 || subStep - 1 == index ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "col-12 absolute left-0 right-0 mx-auto text-center font-medium  ".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().subStepName), " "),
            children: item.name
          }) : null]
        }, index);
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (StepBar);

/***/ }),

/***/ 32144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56727);
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98989);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);







function TabListNew(_ref) {
  var data = _ref.data,
      activeTab = _ref.activeTab,
      tabLinks = _ref.tabLinks,
      tabListClass = _ref.tabListClass,
      tabClass = _ref.tabClass,
      children = _ref.children,
      _onChange = _ref.onChange;
  var tabListStyle = ["rounded-full", tabListClass.display || "flex justify-start lg:justify-center", tabListClass.length || " w-fit mx-auto", tabListClass.background || "bg-transparent", tabListClass.padding || "p-0", tabListClass.border || "border md:border border-bbc-neutral-600", tabListClass.othersClass].join(" ");
  var tabStyle = ["relative select-none rounded-full cursor-pointer border transition-all duration-100 ring-0 outline-none focus:ring-0 focus:outline-0 focus:outline-none text-center", tabClass.width || "w-fit", tabClass.textSize || "text-sm leading-6", tabClass.textFontWeight || "font-semibold", tabClass.padding || "py-3 px-6", tabClass.margin || "", tabClass.othersClass].join(" ");
  /* Handle Event */

  var handleOnClickTabLink = function handleOnClickTabLink(e) {
    e.preventDefault();
    window.history.pushState(null, null, e.target.getAttribute("data-go"));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "w-full",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab.Group */ .OK.Group, {
      defaultIndex: activeTab || 0,
      onChange: function onChange() {
        return _onChange && _onChange();
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab.List */ .OK.List, {
        className: (0,common_functions__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .A)(tabListStyle),
        children: Object.keys(data).length > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab */ .OK, {
            className: function className(_ref2) {
              var selected = _ref2.selected;
              return (0,common_functions__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .A)(tabStyle, selected ? "".concat(tabClass.tabColorActive || "border-bbc-brand-500 text-bbc-brand-500") : " ".concat(tabClass.tabColor || "border-transparent bg-transparent text-bbc-neutral-600 hover:text-bbc-brand-500", " "));
            },
            as: "div",
            children: [item.title || item, Array.isArray(tabLinks) && (tabLinks === null || tabLinks === void 0 ? void 0 : tabLinks.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
              "data-go": "#".concat(tabLinks[index]),
              onClick: handleOnClickTabLink,
              className: "absolute inset-0 h-full w-full"
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {})]
          }, item.id || item);
        })
      }), children]
    })
  });
}

TabListNew.defaultProps = {
  tabListClass: {},
  tabClass: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (TabListNew);

/***/ }),

/***/ 81397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/contexts.js
var contexts = __webpack_require__(72713);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/StepBar/index.js
var StepBar = __webpack_require__(85504);
// EXTERNAL MODULE: ./components/templates/hk/guide-and-tool/hong-kong-cost-planning-tool/index.js + 8 modules
var hong_kong_cost_planning_tool = __webpack_require__(22428);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(30266);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(809);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./common/fetch/getGAUserID.js
var getGAUserID = __webpack_require__(12453);
// EXTERNAL MODULE: ./common/fetch/post.js
var post = __webpack_require__(92559);
// EXTERNAL MODULE: ./common/trigger.js
var trigger = __webpack_require__(62951);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Icon/bi/BiLoaderAlt.js
var BiLoaderAlt = __webpack_require__(7778);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Input/index.js
var Input = __webpack_require__(66865);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/sg/guide-and-tool/singapore-grants-incentives/StartScreen/index.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















function StartScreenGrantsIncentives() {
  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      clearErrors = _useForm.clearErrors,
      _useForm$formState = _useForm.formState,
      isSubmitting = _useForm$formState.isSubmitting,
      errors = _useForm$formState.errors;

  var recaptchaRef = (0,react.useRef)();

  var _useContext = (0,react.useContext)(contexts/* GrantsAndIncentivesContext */.iz),
      setFirstScreen = _useContext.setFirstScreen,
      setUserData = _useContext.setUserData;

  var _useState = (0,react.useState)(false),
      validated = _useState[0],
      setValidated = _useState[1];

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var token, GAUserID, dataSend;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return recaptchaRef.current.executeAsync();

            case 2:
              token = _context.sent;

              if (token) {
                GAUserID = (0,getGAUserID/* default */.Z)();
                dataSend = _objectSpread({}, data);
                dataSend.contact_from_id = 40;
                dataSend.company_country_id = 191;
                dataSend.client_id = GAUserID ? GAUserID : "";
                dataSend.website_id = "1"; // Await axios
                //   .post(
                //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/default`,
                //     Data,
                //     {
                //       Headers: {
                //         "captcha-response": token,
                //       },
                //     }
                // )

                (0,post/* default */.Z)({
                  api: "".concat("https://core.test-lp.bbcincorp.com", "/api/portal/contact_form/default"),
                  data: dataSend,
                  token: token
                }).then(function (res) {
                  if (res.state) {
                    reset();
                    setValidated(false);
                    (0,trigger/* default */.Z)("contact_form", dataSend, "Singapore Grants");
                    clearErrors();
                    setUserData(function (prev) {
                      return _objectSpread(_objectSpread({}, prev), {}, {
                        email: dataSend.email
                      });
                    });
                    setFirstScreen(false);
                  } else {
                    // Temp position to test local storage
                    console.log("error");
                  }
                })["catch"](function (error) {
                  reset();
                  clearErrors();
                  setValidated(false);
                  console.log(error);
                  setUserData({});
                });
              } else {
                reset();
                clearErrors();
                setValidated(false);
                setUserData({});
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: " mt-10 flex justify-center pt-20 md:mt-20",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "row mb-2.5",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "order-last grid place-items-center text-center sm:col-12 lg:col-6 lg:order-first lg:text-left",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
              className: "mb-6",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "bg-gradient-to-r from-red-800 to-red-500 bg-clip-text text-2xl font-semibold leading-9 text-transparent lg:text-bbc-48px",
                children: "SINGAPORE"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "bg-gradient-to-r from-blue-800 to-blue-500 bg-clip-text text-2xl font-semibold leading-9 text-transparent lg:text-bbc-48px",
                children: "Grants & Incentives"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: " mb-12 text-gray-400 ",
              children: "Type in your contact information to receive details about supporting programs in Singapore"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
              noValidate: true,
              validated: validated ? 1 : 0,
              onSubmit: handleSubmit(onSubmit),
              className: "relative mx-auto  lg:mx-0",
              style: {
                maxWidth: "540px"
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input/* InputEmail */.j7, {
                register: register,
                errors: errors,
                name: "email",
                placeholder: "Your email",
                className: "w-full rounded-full border border-bbc-neutral-400 py-2 px-4 leading-8 text-bbc-gray placeholder-gray-400 focus:border-bbc-neutral-400 focus:ring-0"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: " mt-4 grid justify-center lg:mt-8 lg:justify-start",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.Z, {
                  ref: recaptchaRef,
                  sitekey: "6LeJZ68UAAAAAJZ8jxdgylEXeWL8P9Ckv7CLtE6t",
                  badge: "inline",
                  size: "invisible"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mt-4 mb-10 block text-center lg:mb-0 lg:inline-block",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
                  disabled: isSubmitting,
                  othersClass: "uppercase lg:w-auto lg:absolute right-1 top-1 flex mx-auto",
                  onClick: function onClick() {
                    setValidated(true);
                  },
                  children: isSubmitting ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BiLoaderAlt/* BiLoaderAlt */.s, {
                      className: "mr-2 animate-spin",
                      size: 20
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: "Loading"
                    })]
                  }) : "Start Now"
                })
              })]
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "items-center sm:col-12 sm:order-1 sm:flex lg:col-6",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            src: "/assets/images/sg/guide-and-tool/singapore-grants-incentives/singapore-sg-grants.png",
            alt: "singapore-grants-incentives",
            loading: "lazy",
            className: "mb-10 lg:mb-0",
            width: 540,
            height: 402
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-6 font-medium text-gray-600",
        children: "Disclaimer"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: " text-gray-600",
        children: "The information contained in this tool is for general information purpose only. You should not substitute the information provided in this tool for competent legal advice. For a further in-depth understanding of Singapore grants & incentives, please engage professional advice."
      })]
    })
  });
}
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 2 modules
var react_select_esm = __webpack_require__(99973);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/io5/IoChevronDown.js

function IoChevronDown(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "48",
        "d": "M112 184l144 144 144-144"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/templates/sg/guide-and-tool/singapore-grants-incentives/Index.module.scss
var Index_module = __webpack_require__(64792);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
;// CONCATENATED MODULE: ./components/templates/sg/guide-and-tool/singapore-grants-incentives/step2/index.js


function step2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function step2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { step2_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { step2_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-prototype-builtins */










var customStyles = {
  container: function container(provided) {
    return step2_objectSpread({}, provided);
  },
  control: function control(provided) {
    return step2_objectSpread(step2_objectSpread({}, provided), {}, {
      color: "#333",
      borderRadius: 10,
      padding: "16px 24px",
      lineHeight: "26px",
      borderWidth: "0.5px",
      borderColor: "#007EFF !important",
      boxShadow: "none",
      fontWeight: "500",
      cursor: "pointer"
    });
  },
  valueContainer: function valueContainer(provided) {
    return step2_objectSpread(step2_objectSpread({}, provided), {}, {
      padding: 0,
      margin: 0
    });
  },
  menu: function menu(provided) {
    return step2_objectSpread(step2_objectSpread({}, provided), {}, {
      borderRadius: 10,
      overflow: "hidden"
    });
  },
  menuList: function menuList(provided) {
    return step2_objectSpread(step2_objectSpread({}, provided), {}, {
      padding: 0
    });
  },
  option: function option(provided, state) {
    return step2_objectSpread(step2_objectSpread({}, provided), {}, {
      padding: "8px 16px",
      color: state.isRegistered ? "#007eff" : "#333",
      background: state.isRegistered || state.isFocused ? "#F1FBFF" : "",
      fontWeight: state.isRegistered ? "600" : "normal"
    });
  },
  placeholder: function placeholder(provided) {
    return step2_objectSpread(step2_objectSpread({}, provided), {}, {
      padding: 0,
      margin: 0,
      color: "#333"
    });
  },
  input: function input(provided) {
    return step2_objectSpread(step2_objectSpread({}, provided), {}, {
      padding: 0,
      margin: 0,
      lineHeight: "26px"
    });
  },
  indicatorSeparator: function indicatorSeparator(provided) {
    return step2_objectSpread(step2_objectSpread({}, provided), {}, {
      backgroundColor: "transparent"
    });
  },
  clearIndicator: function clearIndicator(provided) {
    return step2_objectSpread(step2_objectSpread({}, provided), {}, {
      padding: "0px"
    });
  }
};
var registeredOptions = [{
  name: "Yes",
  value: true
}, {
  name: "No",
  value: false
}];

function Step2(_ref) {
  var _companyNameRef$curre, _companyNameRef$curre2;

  var data = _ref.data;

  var _useContext = (0,react.useContext)(contexts/* GrantsAndIncentivesContext */.iz),
      setStep = _useContext.setStep,
      dataStep2 = _useContext.dataStep2,
      setDataStep2 = _useContext.setDataStep2;

  var years_operation = data.years_operation,
      business_size = data.business_size,
      local_shareholding = data.local_shareholding,
      number_employees = data.number_employees,
      country_id = data.country_id;
  var companyNameRef = (0,react.useRef)();

  var _useState = (0,react.useState)(dataStep2.country_id ? dataStep2.country_id === 191 : null),
      registered = _useState[0],
      setRegistered = _useState[1];

  var _useState2 = (0,react.useState)(false),
      rerender = _useState2[0],
      setRerender = _useState2[1]; // Const handleOnChangeStep = () => {
  //   SetDataStep2((prev) => ({
  //     ...prev,
  //     Company_name: companyNameRef.current.value,
  //     Sg_registered: registered,
  //   }));
  // };


  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((Index_module_default()).step2, " relative z-30"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "".concat((Index_module_default()).title),
          children: "Your company name"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          id: "company_name",
          ref: companyNameRef,
          className: "".concat((Index_module_default()).companyName),
          placeholder: "Company name",
          defaultValue: dataStep2.company_name,
          onChange: function onChange(e) {
            setTimeout(function () {
              setDataStep2(function (prev) {
                return step2_objectSpread(step2_objectSpread({}, prev), {}, {
                  company_name: e.target.value
                });
              });
            }, 300);
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "".concat((Index_module_default()).title),
          children: "Registered in Singapore?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* RadioGroup */.Ee, {
          value: registered,
          onChange: function onChange(value) {
            setDataStep2(function (prev) {
              return step2_objectSpread(step2_objectSpread({}, prev), {}, {
                country_id: value ? country_id : 2
              });
            });
            setRegistered(value);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "space-y-2",
            children: registeredOptions.map(function (plan) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* RadioGroup.Option */.Ee.Option, {
                value: plan.value,
                className: function className(_ref2) {
                  var checked = _ref2.checked;
                  return "\n                    transition-colors duration-150\n                  ".concat(checked ? "bg-bbc-brand-500 text-white" : "bg-white", "\n                    relative flex cursor-pointer rounded-lg border border-bbc-brand-500 px-6 py-4 focus:outline-none focus:ring-0");
                },
                children: function children(_ref3) {
                  var checked = _ref3.checked;
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* RadioGroup.Label */.Ee.Label, {
                      as: "p",
                      className: "font-medium leading-bbc-26  ".concat(checked ? "text-white" : "text-gray-900"),
                      children: plan.name
                    })
                  });
                }
              }, plan.name);
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "".concat((Index_module_default()).title),
          children: "Years in operation"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
          defaultValue: dataStep2.years_operation_hold,
          options: years_operation,
          isSearchable: false,
          inputMode: "search",
          placeholder: "Types...",
          styles: customStyles,
          components: {
            IndicatorsContainer: function IndicatorsContainer() {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(IoChevronDown, {
                className: "cursor-pointer",
                size: 20
              });
            }
          },
          onChange: function onChange(value) {
            setDataStep2(function (prev) {
              return step2_objectSpread(step2_objectSpread({}, prev), {}, {
                years_operation_hold: value,
                years_operation: value.value
              });
            });
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "".concat((Index_module_default()).title),
          children: "Annual turnover in SGD"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
          defaultValue: dataStep2.business_size_hold,
          isClearable: true,
          options: business_size,
          isSearchable: false,
          inputMode: "search",
          placeholder: "Types...",
          styles: customStyles,
          components: {
            DropdownIndicator: function DropdownIndicator() {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(IoChevronDown, {
                className: "cursor-pointer",
                size: 20
              });
            }
          },
          onChange: function onChange(value) {
            if (value) {
              setDataStep2(function (prev) {
                return step2_objectSpread(step2_objectSpread({}, prev), {}, {
                  business_size_hold: value,
                  business_size: value.value
                });
              });
            } else {
              var temp = dataStep2;
              delete temp.business_size_hold;
              delete temp.business_size;
              setDataStep2(temp);
              setRerender(!rerender);
            }
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "".concat((Index_module_default()).title),
          children: "Number of employees"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
          defaultValue: dataStep2.number_employees_hold,
          isClearable: true,
          options: number_employees,
          isSearchable: false,
          inputMode: "search",
          placeholder: "Types...",
          styles: customStyles,
          components: {
            DropdownIndicator: function DropdownIndicator() {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(IoChevronDown, {
                className: "cursor-pointer",
                size: 20
              });
            }
          },
          onChange: function onChange(value) {
            if (value) {
              setDataStep2(function (prev) {
                return step2_objectSpread(step2_objectSpread({}, prev), {}, {
                  number_employees_hold: value,
                  number_employees: value.value
                });
              });
            } else {
              var temp = dataStep2;
              delete temp.number_employees_hold;
              delete temp.number_employees;
              setDataStep2(temp);
              setRerender(!rerender);
            }
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "".concat((Index_module_default()).title),
          children: "% local shareholding by Singaporean or Permanent Resident (PR)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
          defaultValue: dataStep2.local_shareholding_hold,
          options: local_shareholding,
          isSearchable: false,
          inputMode: "search",
          placeholder: "Types...",
          styles: customStyles,
          components: {
            DropdownIndicator: function DropdownIndicator() {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(IoChevronDown, {
                className: "cursor-pointer",
                size: 20
              });
            }
          },
          onChange: function onChange(value) {
            setDataStep2(function (prev) {
              return step2_objectSpread(step2_objectSpread({}, prev), {}, {
                local_shareholding_hold: value,
                local_shareholding: value.value
              });
            });
          }
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex justify-between",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
        variant: "ghost",
        btnPadding: "px-0 py-0",
        onClick: function onClick() {
          // HandleOnChangeStep();
          setStep(function (prev) {
            return prev - 1;
          });
        },
        btnColor: "text-bbc-neutral-600 hover:text-bbc-neutral-700",
        children: "Back"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
        disabled: ((_companyNameRef$curre = companyNameRef.current) === null || _companyNameRef$curre === void 0 ? void 0 : (_companyNameRef$curre2 = _companyNameRef$curre.value) === null || _companyNameRef$curre2 === void 0 ? void 0 : _companyNameRef$curre2.length) == 0 || registered === null || Object.keys(dataStep2).length < 8 || !dataStep2.hasOwnProperty("years_operation") || !dataStep2.hasOwnProperty("local_shareholding"),
        variant: "ghost",
        btnPadding: "px-0 py-0",
        othersClass: (Index_module_default()).disabledBtn,
        onClick: function onClick() {
          // HandleOnChangeStep();
          setStep(function (prev) {
            return prev + 1;
          });
        },
        children: "Next"
      })]
    })]
  });
}

/* harmony default export */ var step2 = (Step2);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(40037);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./common/lodash/getUniqueListBy.js

function getUniqueListBy(arr, key) {
  return (0,toConsumableArray/* default */.Z)(new Map(arr === null || arr === void 0 ? void 0 : arr.map(function (item) {
    return [item[key], item];
  })).values());
}
;// CONCATENATED MODULE: ./components/atoms/Icon/ai/AiFillCaretDown.js

function AiFillCaretDown(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 1024 1024"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
      }
    }]
  })(props);
}
// EXTERNAL MODULE: ./components/atoms/Icon/fi/FiFilter.js
var FiFilter = __webpack_require__(28613);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91164);
;// CONCATENATED MODULE: ./components/atoms/Popup/index.js


var _excluded = ["components", "children", "className", "closeButton", "onClose", "onOpen", "disableAccessibility"];

function Popup_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Popup_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Popup_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Popup_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Popup = function Popup(_ref) {
  var components = _ref.components,
      children = _ref.children,
      className = _ref.className,
      closeButton = _ref.closeButton,
      onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      disableAccessibility = _ref.disableAccessibility,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var CloseButton = closeButton;

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var openButtonRef = (0,react.useRef)(null);

  function closeModal(event) {
    // Chỉ cho phép tắt popup khi popup đang mở
    if (isOpen) {
      setIsOpen(false);
      if (onClose) onClose(event);
    }
  }

  function openModal(event) {
    // Chỉ cho phép bật popup khi popup chưa được mở
    if (!isOpen) {
      setIsOpen(true);
      if (onOpen) onOpen(event);
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", Popup_objectSpread(Popup_objectSpread({
      // Fix: "...there are no focusable elements"
      ref: openButtonRef,
      type: "button",
      onClick: openModal,
      className: "focus:right-0 focus:outline-none ".concat(className)
    }, props), {}, {
      children: children
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
      appear: true,
      show: isOpen,
      as: "div",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Dialog */.Vq, {
        as: "div",
        className: "fixed inset-0 overflow-y-auto" // Disable mouse interaction (outside click) & keyboard interaction
        ,
        onClose: disableAccessibility ? function () {} : closeModal,
        style: {
          zIndex: 51
        } // Fix there are no focusable elements
        ,
        initialFocus: openButtonRef,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex min-h-screen items-center justify-center px-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
            as: "div",
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Dialog.Overlay */.Vq.Overlay, {
              className: "fixed inset-0 bg-slate-900 bg-opacity-70"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "inline-block h-screen align-middle",
            "aria-hidden": "true",
            children: "\u200B"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Transition.Child */.uT.Child, {
            as: "div",
            className: "relative z-50",
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 scale-95",
            enterTo: "opacity-100 scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 scale-100",
            leaveTo: "opacity-0 scale-95",
            children: [components, CloseButton && /*#__PURE__*/(0,react.isValidElement)( /*#__PURE__*/(0,jsx_runtime.jsx)(CloseButton, {})) && /*#__PURE__*/(0,jsx_runtime.jsx)(CloseButton, {
              onClick: closeModal
            })]
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var atoms_Popup = (Popup);
// EXTERNAL MODULE: ./components/atoms/Recaptcha/index.js
var Recaptcha = __webpack_require__(78762);
// EXTERNAL MODULE: ./components/atoms/Toast/index.js
var Toast = __webpack_require__(85882);
// EXTERNAL MODULE: ./components/atoms/Icon/hi/HiChevronLeft.js
var HiChevronLeft = __webpack_require__(9838);
;// CONCATENATED MODULE: ./components/templates/sg/guide-and-tool/singapore-grants-incentives/step3/Pagination.js






function Pagination(_ref) {
  var _ref$pages = _ref.pages,
      pages = _ref$pages === void 0 ? 6 : _ref$pages,
      setCurrentPage = _ref.setCurrentPage;
  // Set number of pages
  var numberOfPages = [];

  for (var i = 1; i <= pages; i++) {
    numberOfPages.push(i);
  } // Current active button number


  var _useState = (0,react.useState)(1),
      currentButton = _useState[0],
      setCurrentButton = _useState[1]; // Array of buttons what we see on the page


  var _useState2 = (0,react.useState)([]),
      arrOfCurrButtons = _useState2[0],
      setArrOfCurrButtons = _useState2[1];

  (0,react.useEffect)(function () {
    var tempNumberOfPages = (0,toConsumableArray/* default */.Z)(arrOfCurrButtons);

    var dotsInitial = "...";
    var dotsLeft = "... ";
    var dotsRight = " ...";

    if (numberOfPages.length < 10) {
      tempNumberOfPages = numberOfPages;
    } else if (currentButton >= 1 && currentButton <= 3) {
      tempNumberOfPages = [1, 2, 3, 4, dotsInitial, numberOfPages.length];
    } else if (currentButton === 4) {
      var sliced = numberOfPages.slice(0, 5);
      tempNumberOfPages = [].concat((0,toConsumableArray/* default */.Z)(sliced), [dotsInitial, numberOfPages.length]);
    } else if (currentButton > 4 && currentButton < numberOfPages.length - 2) {
      // From 5 to 8 -> (10 - 2)
      var sliced1 = numberOfPages.slice(currentButton - 2, currentButton); // Sliced1 (5-2, 5) -> [4,5]

      var sliced2 = numberOfPages.slice(currentButton, currentButton + 1); // Sliced1 (5, 5+1) -> [6]

      tempNumberOfPages = [1, dotsLeft].concat((0,toConsumableArray/* default */.Z)(sliced1), (0,toConsumableArray/* default */.Z)(sliced2), [dotsRight, numberOfPages.length]); // [1, '...', 4, 5, 6, '...', 10]
    } else if (currentButton > numberOfPages.length - 3) {
      // > 7
      var _sliced = numberOfPages.slice(numberOfPages.length - 4); // Slice(10-4)


      tempNumberOfPages = [1, dotsLeft].concat((0,toConsumableArray/* default */.Z)(_sliced));
    } else if (currentButton === dotsInitial) {
      // Array [1, 2, 3, 4, "...", 10].length = 6 - 3  = 3
      // ArrOfCurrButtons[3] = 4 + 1 = 5
      // Or
      // [1, 2, 3, 4, 5, "...", 10].length = 7 - 3 = 4
      // [1, 2, 3, 4, 5, "...", 10][4] = 5 + 1 = 6
      setCurrentButton(arrOfCurrButtons[arrOfCurrButtons.length - 3] + 1);
    } else if (currentButton === dotsRight) {
      setCurrentButton(arrOfCurrButtons[3] + 2);
    } else if (currentButton === dotsLeft) {
      setCurrentButton(arrOfCurrButtons[3] - 2);
    }

    setArrOfCurrButtons(tempNumberOfPages);
    setCurrentPage(currentButton);
  }, [currentButton, pages]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex items-center justify-center",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      onClick: function onClick() {
        return setCurrentButton(function (prev) {
          return prev <= 1 ? prev : prev - 1;
        });
      },
      disabled: currentButton === 1,
      className: "mr-4 disabled:grayscale",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HiChevronLeft/* HiChevronLeft */.D, {
        size: 24,
        color: "#007eff",
        className: "rounded-md bg-bbc-brand-100 p-0.5"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "flex list-none flex-wrap justify-center rounded pl-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: arrOfCurrButtons.map(function (number, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            onClick: function onClick() {
              setCurrentButton(number);
            },
            className: "px-2 ".concat(currentButton === number ? "font-medium text-bbc-brand-500 underline" : " text-bbc-neutral-700"),
            children: number
          }, index);
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      onClick: function onClick() {
        return setCurrentButton(function (prev) {
          return prev >= numberOfPages.length ? prev : prev + 1;
        });
      },
      disabled: currentButton === numberOfPages.length,
      className: "ml-4 disabled:grayscale",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HiChevronLeft/* HiChevronLeft */.D, {
        size: 24,
        color: "#007eff",
        className: "rotate-180 rounded-md bg-bbc-brand-100 p-0.5"
      })
    })]
  });
}

/* harmony default export */ var step3_Pagination = (Pagination);
// EXTERNAL MODULE: ./components/templates/sg/guide-and-tool/singapore-grants-incentives/step3/Index.module.scss
var step3_Index_module = __webpack_require__(33457);
var step3_Index_module_default = /*#__PURE__*/__webpack_require__.n(step3_Index_module);
;// CONCATENATED MODULE: ./components/templates/sg/guide-and-tool/singapore-grants-incentives/step3/index.js





function step3_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function step3_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { step3_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { step3_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable prefer-spread */





















var step3_customStyles = {
  container: function container(provided) {
    return step3_objectSpread(step3_objectSpread({}, provided), {}, {
      minWidth: 185
    });
  },
  control: function control(provided) {
    return step3_objectSpread(step3_objectSpread({}, provided), {}, {
      color: "#333",
      borderRadius: 10,
      padding: "12px 24px",
      lineHeight: "26px",
      borderWidth: "0.5px",
      backgroundColor: "#F5F5F5",
      boxShadow: "none",
      fontWeight: "500",
      cursor: "pointer"
    });
  },
  valueContainer: function valueContainer(provided) {
    return step3_objectSpread(step3_objectSpread({}, provided), {}, {
      padding: 0,
      margin: 0
    });
  },
  menu: function menu(provided) {
    return step3_objectSpread(step3_objectSpread({}, provided), {}, {
      borderRadius: 10,
      overflow: "hidden"
    });
  },
  menuList: function menuList(provided) {
    return step3_objectSpread(step3_objectSpread({}, provided), {}, {
      padding: 0
    });
  },
  option: function option(provided, state) {
    return step3_objectSpread(step3_objectSpread({}, provided), {}, {
      padding: "8px 16px",
      color: state.isSelected ? "#007eff" : "#333",
      background: state.isSelected || state.isFocused ? "#F1FBFF" : "",
      fontWeight: state.isSelected ? "600" : "normal"
    });
  },
  placeholder: function placeholder(provided) {
    return step3_objectSpread(step3_objectSpread({}, provided), {}, {
      padding: 0,
      margin: 0,
      color: "#333"
    });
  },
  input: function input(provided) {
    return step3_objectSpread(step3_objectSpread({}, provided), {}, {
      padding: 0,
      margin: 0,
      lineHeight: "26px"
    });
  },
  indicatorSeparator: function indicatorSeparator(provided) {
    return step3_objectSpread(step3_objectSpread({}, provided), {}, {
      backgroundColor: "transparent"
    });
  },
  clearIndicator: function clearIndicator(provided) {
    return step3_objectSpread(step3_objectSpread({}, provided), {}, {
      padding: "0px"
    });
  }
};

function Step3Layout() {
  var _useContext = (0,react.useContext)(contexts/* GrantsAndIncentivesContext */.iz),
      setStep = _useContext.setStep,
      userData = _useContext.userData,
      dataStep1 = _useContext.dataStep1,
      dataStep2 = _useContext.dataStep2,
      reset = _useContext.reset;

  var recaptchaRef = (0,react.useRef)();

  var _useContext2 = (0,react.useContext)(contexts/* ToastContext */.uL),
      openAlert = _useContext2.openAlert;

  var _useState = (0,react.useState)(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0,react.useState)([]),
      holdGrants = _useState2[0],
      setHoldGrants = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      grants = _useState3[0],
      setGrants = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      types = _useState4[0],
      setTypes = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      agencies = _useState5[0],
      setAgencies = _useState5[1];

  var _useState6 = (0,react.useState)(null),
      selectedTypes = _useState6[0],
      setSelectedTypes = _useState6[1];

  var _useState7 = (0,react.useState)(null),
      selectedAgency = _useState7[0],
      setSelectedAgency = _useState7[1];

  var _useState8 = (0,react.useState)(1),
      currentPage = _useState8[0],
      setCurrentPage = _useState8[1];

  var _useState9 = (0,react.useState)(6),
      grantsPerPage = _useState9[0];

  var _useState10 = (0,react.useState)([]),
      selectedGrants = _useState10[0],
      setSelectedGrants = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      isSubmitting = _useState11[0],
      setIsSubmitting = _useState11[1]; // Get current grants


  var indexOfLastPost = currentPage * grantsPerPage;
  var indexOfFirstPost = indexOfLastPost - grantsPerPage;
  var currentGrants = grants === null || grants === void 0 ? void 0 : grants.slice(indexOfFirstPost, indexOfLastPost);

  var _useState12 = (0,react.useState)(0),
      howManyPages = _useState12[0],
      setHowManyPages = _useState12[1];

  var _dataStep1$dataStep = step3_objectSpread(step3_objectSpread({}, dataStep1), dataStep2),
      needs_based = _dataStep1$dataStep.needs_based,
      business_stage = _dataStep1$dataStep.business_stage,
      industry = _dataStep1$dataStep.industry,
      years_operation = _dataStep1$dataStep.years_operation,
      business_size = _dataStep1$dataStep.business_size,
      number_employees = _dataStep1$dataStep.number_employees,
      local_shareholding = _dataStep1$dataStep.local_shareholding,
      country_id = _dataStep1$dataStep.country_id;

  var _useState13 = (0,react.useState)(step3_objectSpread(step3_objectSpread(step3_objectSpread({
    needs_based_id: needs_based,
    industry_id: industry,
    business_stage_id: business_stage,
    years_operation_id: years_operation,
    local_shareholding_id: local_shareholding
  }, business_size && {
    business_size_id: business_size
  }), number_employees && {
    number_employees_id: number_employees
  }), country_id === 191 && {
    country_id: country_id
  })),
      params = _useState13[0]; // Fetch grants


  (0,react.useEffect)(function () {
    var fetchPosts = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var api_link, res, custom_res_data, getTypes, getAgencies;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setLoading(true);
                api_link = "".concat("https://core.test-lp.bbcincorp.com", "/api/portal/tools/grant_scheme");

                if (!(needs_based && industry && business_stage && years_operation && local_shareholding && (business_size || number_employees))) {
                  _context.next = 13;
                  break;
                }

                _context.next = 5;
                return axios_default().get(api_link, {
                  params: params
                });

              case 5:
                res = _context.sent;
                custom_res_data = getUniqueListBy(res.data.data.rows, "id");
                getTypes = getUniqueListBy([].concat.apply([], custom_res_data.map(function (item) {
                  return item.type;
                })).map(function (item) {
                  return {
                    label: item,
                    value: item
                  };
                }), "label");
                getAgencies = getUniqueListBy([].concat.apply([], custom_res_data.map(function (item) {
                  return item.agency;
                })).map(function (item) {
                  return {
                    label: item,
                    value: item
                  };
                }), "label");
                setHowManyPages(Math.ceil(custom_res_data.length / grantsPerPage));
                setTimeout(function () {
                  setGrants(custom_res_data);
                  setTypes(getTypes);
                  setAgencies(getAgencies);
                  setHoldGrants(custom_res_data);
                  setLoading(false);
                }, 500);
                _context.next = 17;
                break;

              case 13:
                setHowManyPages(0);
                setGrants([]);
                setHoldGrants([]);
                setLoading(false);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchPosts() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchPosts();
  }, [dataStep1, dataStep2]);
  (0,react.useEffect)(function () {
    if (selectedTypes && selectedAgency) {
      setGrants(holdGrants.filter(function (item) {
        var _item$agency;

        return item.type.some(function (typeItem) {
          return typeItem.localeCompare(selectedTypes.label) === 0;
        }) && ((_item$agency = item.agency) === null || _item$agency === void 0 ? void 0 : _item$agency.some(function (agencyItem) {
          return agencyItem.localeCompare(selectedAgency.label) === 0;
        }));
      }));
    } else if (selectedTypes || selectedAgency) {
      if (selectedTypes) {
        setGrants(holdGrants.filter(function (item) {
          return item.type.some(function (typeItem) {
            return typeItem.localeCompare(selectedTypes.label) === 0;
          });
        }));
      }

      if (selectedAgency) {
        setGrants(holdGrants.filter(function (item) {
          var _item$agency2;

          return (_item$agency2 = item.agency) === null || _item$agency2 === void 0 ? void 0 : _item$agency2.some(function (agencyItem) {
            return agencyItem.localeCompare(selectedAgency.label) === 0;
          });
        }));
      }
    } else {
      setGrants(holdGrants);
    }

    setSelectedGrants([]);
    setCurrentPage(1);
  }, [selectedTypes, selectedAgency]);
  (0,react.useEffect)(function () {
    var count = Math.ceil(grants.length / grantsPerPage);
    setHowManyPages(count > 0 ? count : 1);
  }, [grants]);

  var onSendData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var token, GAUserID, dataSend;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return recaptchaRef.current.executeAsync();

            case 2:
              token = _context2.sent;

              if (!(token && selectedGrants.length > 0)) {
                _context2.next = 18;
                break;
              }

              GAUserID = (0,getGAUserID/* default */.Z)();
              dataSend = {};
              dataSend.client_id = GAUserID ? GAUserID : "";
              dataSend.website_id = "1";
              dataSend.list_grant_scheme_id = holdGrants.map(function (item) {
                return item.id;
              });
              dataSend.email = userData.email;
              dataSend.list_grant_scheme_checked_id = selectedGrants.map(function (item) {
                return item.id;
              }); // List client checkbox

              dataSend.company_name = dataStep2.company_name;
              dataSend = step3_objectSpread(step3_objectSpread({}, dataSend), params);
              delete dataSend.years_operation_id;
              _context2.next = 16;
              return axios_default().post("".concat("https://core.test-lp.bbcincorp.com", "/api/portal/tools/grant_scheme/mail_send_me_program_details"), dataSend, {
                headers: {
                  "captcha-response": token
                }
              }).then(function (res) {
                if (res.data.state) {
                  // Trigger("contact_form", data, "Contact Form - Singapore Grants");
                  openAlert(3000, "success");
                } else {
                  // Temp position to test local storage
                  console.log("error");
                }
              })["catch"](function (error) {
                console.log(error);
                openAlert(3000, "error");
              });

            case 16:
              _context2.next = 19;
              break;

            case 18:
              openAlert(3000, "error");

            case 19:
              setIsSubmitting(false);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onSendData() {
      return _ref2.apply(this, arguments);
    };
  }();

  var renderResult = function renderResult() {
    if (loading && grants.length === 0) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: "flex items-center justify-center",
        style: {
          height: "1000px"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BiLoaderAlt/* BiLoaderAlt */.s, {
          className: "absolute mr-2 animate-spin",
          size: 24
        })
      });
    }

    if (currentGrants.length > 0) {
      if (howManyPages > 1) return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ListGrant, {
          data: currentGrants,
          selectedGrants: selectedGrants,
          setSelectedGrants: setSelectedGrants,
          selectedTypes: selectedTypes,
          selectedAgency: selectedAgency
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(step3_Pagination, {
          pages: howManyPages,
          setCurrentPage: setCurrentPage
        })]
      });
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ListGrant, {
        data: currentGrants,
        selectedGrants: selectedGrants,
        setSelectedGrants: setSelectedGrants,
        selectedTypes: selectedTypes,
        selectedAgency: selectedAgency
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mb-10 bg-bbc-yellow-300 bg-opacity-30 p-4 text-center",
      children: "No Result"
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: " ".concat((Index_module_default()).step3),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-10 flex ",
        children: (holdGrants === null || holdGrants === void 0 ? void 0 : holdGrants.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mr-4 flex items-center  text-bbc-neutral-700 lg:mr-10",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FiFilter/* FiFilter */.I, {
              className: "m-1 inline-block",
              style: {
                minWidth: "20px",
                minHeight: "20px"
              }
            }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "whitespace-nowrap",
              children: "Filter by"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-wrap",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
              isClearable: true,
              isDisabled: holdGrants.length === 0,
              options: types,
              isSearchable: true,
              inputMode: "search",
              placeholder: "Type",
              styles: step3_customStyles,
              className: "mb-2 w-full md:my-1 md:mr-6 md:mb-0 md:w-fit",
              components: {
                DropdownIndicator: function DropdownIndicator() {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(IoChevronDown, {
                    className: "cursor-pointer",
                    size: 20
                  });
                }
              },
              onChange: function onChange(value) {
                setSelectedTypes(value);
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
              isClearable: true,
              isDisabled: holdGrants.length === 0,
              options: agencies,
              isSearchable: true,
              inputMode: "search",
              placeholder: "Agency",
              styles: step3_customStyles,
              className: "w-full md:my-1 md:w-fit",
              components: {
                DropdownIndicator: function DropdownIndicator() {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(IoChevronDown, {
                    className: "cursor-pointer",
                    size: 20
                  });
                }
              },
              onChange: function onChange(value) {
                setSelectedAgency(value);
              }
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "my-10 ",
        children: renderResult()
      }), (holdGrants === null || holdGrants === void 0 ? void 0 : holdGrants.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "rounded-xl border border-dashed border-bbc-brand-200 bg-bbc-brand-100 p-6",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/icons/note.svg",
          width: 139,
          height: 58,
          alt: "note"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-bbc-secondary-400",
          children: "You can select up to 3 supporting programs to be sent to your email."
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "text-center",
      children: [(holdGrants === null || holdGrants === void 0 ? void 0 : holdGrants.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonNew/* default */.Z, {
          disabled: holdGrants.length === 0 || selectedGrants.length === 0 || isSubmitting,
          btnPadding: "px-10 py-2",
          othersClass: "mb-10 lg:mb-6 relative",
          onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
            return regenerator_default().wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    setIsSubmitting(true);
                    _context3.next = 3;
                    return onSendData();

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          })),
          children: [isSubmitting && /*#__PURE__*/(0,jsx_runtime.jsx)(BiLoaderAlt/* BiLoaderAlt */.s, {
            className: "absolute left-2 animate-spin",
            size: 24
          }), "Send me all program details"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "invisible h-0 w-0",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Recaptcha/* default */.Z, {
            ref: recaptchaRef
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [(holdGrants === null || holdGrants === void 0 ? void 0 : holdGrants.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "font-medium",
          children: "Or "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
          variant: "ghost",
          btnPadding: "px-0 py-0",
          onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
            return regenerator_default().wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return Tawk_API.toggle();

                  case 2:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          })),
          children: "Chat with our consultant"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mt-6 flex justify-between",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
        variant: "ghost",
        btnPadding: "px-0 py-0",
        onClick: function onClick() {
          setStep(function (prev) {
            return prev - 1;
          });
        },
        btnColor: "text-bbc-neutral-600 hover:text-bbc-neutral-700",
        children: "Back"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
        variant: "ghost",
        btnPadding: "px-0 py-0",
        onClick: function onClick() {
          openAlert(false, "confirm", {
            title: "Are you sure?",
            onClick: function onClick() {
              reset();
            }
          });
        },
        children: "Retake Assessment"
      })]
    })]
  });
}

function Step3(_ref5) {
  var data = _ref5.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Toast/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Step3Layout, {
      data: data
    })
  });
}

var ListGrant = function ListGrant(_ref6) {
  var data = _ref6.data,
      selectedGrants = _ref6.selectedGrants,
      setSelectedGrants = _ref6.setSelectedGrants,
      selectedAgency = _ref6.selectedAgency;

  /* Handle Event */
  var isTypeInSelectedGrants = function isTypeInSelectedGrants() {
    // If (selectedTypes || selectedAgency) {
    //   Return false;
    // }
    // Return selectedGrants.findIndex((item) => item.type === grant.type) >= 0;
    return false;
  };

  var isSelectedGrant = function isSelectedGrant(grant) {
    return selectedGrants.findIndex(function (item) {
      return item.name === grant.name;
    }) >= 0;
  };

  var handleOnLickGrants = function handleOnLickGrants(grant) {
    var isSelected = isSelectedGrant(grant);

    var tempSelected = (0,toConsumableArray/* default */.Z)(selectedGrants);

    if (isSelected) {
      setSelectedGrants(tempSelected.filter(function (item) {
        return item.name !== grant.name;
      }));
    } else {
      if (selectedGrants.length < 3) {
        setSelectedGrants([].concat((0,toConsumableArray/* default */.Z)(tempSelected), [grant]));
      }
    }
  };
  /* Define component local */


  var CardGrant = function CardGrant(_ref7) {
    var data = _ref7.data;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex w-full justify-between bg-bbc-brand-700 p-6",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            disabled: (selectedGrants.length >= 3 || isTypeInSelectedGrants(data)) && !isSelectedGrant(data),
            type: "checkbox",
            className: " bbc-checkbox mr-2 mt-1 h-6 w-6 rounded-md ".concat((step3_Index_module_default()).checkbox, " "),
            checked: isSelectedGrant(data),
            onChange: function onChange() {
              handleOnLickGrants(data);
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-white ",
            children: data.agency.length > 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: " pl-4",
                children: data.agency.map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "list-disc",
                    children: item
                  }, index);
                })
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: data.agency[0]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "ml-4 text-sm font-medium leading-6 text-bbc-yellow-500",
          children: data.type
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative flex h-full items-start p-6 ",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-col",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-4 font-medium text-bbc-brand-700",
            children: data.name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "whitespace-pre-line text-bbc-gray",
            children: data.description
          })]
        })
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mb-10 grid-flow-row grid-cols-2 gap-x-7 gap-y-8 md:grid",
      children: data.map(function (item, index) {
        var agency_show = item.agency[0];

        if (selectedAgency) {
          agency_show = selectedAgency.label;
        }

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: {
            maxWidth: "500px"
          },
          className: "mx-auto mb-10 flex flex-col overflow-hidden rounded-lg border border-bbc-neutral-600 md:mb-0 ".concat(isSelectedGrant(item) ? "bg-yellow-50" : "bg-transparent"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex w-full cursor-pointer items-center justify-between bg-bbc-brand-700 px-6 py-2",
            onClick: function onClick() {
              handleOnLickGrants(item);
            },
            style: {
              minHeight: "76px"
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex items-start",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                disabled: (selectedGrants.length >= 3 || isTypeInSelectedGrants(item)) && !isSelectedGrant(item),
                type: "checkbox",
                className: " bbc-checkbox mr-2 mt-0.5 h-6 w-6 rounded-md ".concat((step3_Index_module_default()).checkbox, " "),
                checked: isSelectedGrant(item),
                onChange: function onChange() {
                  handleOnLickGrants(item);
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: " text-white ",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "inline-block line-clamp-2",
                  children: [agency_show, " ", item.agency.length > 1 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: ["& ", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      children: [item.agency.length - 1, " Others Agency "]
                    }), " "]
                  })]
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "ml-4 text-sm font-medium leading-6 text-bbc-yellow-500 ",
              children: item.type
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "relative flex h-full items-start p-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex h-full flex-col justify-between",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex-1",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "mb-4 font-medium text-bbc-brand-700 line-clamp-3",
                  children: item.name
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "whitespace-pre-line text-bbc-gray  line-clamp-3",
                  children: item.description
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_Popup, {
                components: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "m-auto overflow-hidden rounded-lg bg-white lg:max-w-3xl",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardGrant, {
                    data: item
                  })
                }),
                children: (item.agency.length > 1 || item.description.length > 150) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "mt-3 text-right text-bbc-brand-600  hover:underline ",
                  children: ["See more ", /*#__PURE__*/(0,jsx_runtime.jsx)(AiFillCaretDown, {
                    className: "inline-block"
                  })]
                })
              })]
            })
          })]
        }, index);
      })
    })
  });
};
// EXTERNAL MODULE: ./node_modules/react-select/dist/index-a86253bb.esm.js + 3 modules
var index_a86253bb_esm = __webpack_require__(57003);
;// CONCATENATED MODULE: ./components/templates/sg/guide-and-tool/singapore-grants-incentives/step1/index.js



function step1_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function step1_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { step1_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { step1_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var step1_customStyles = {
  container: function container(provided) {
    return step1_objectSpread({}, provided);
  },
  control: function control(provided) {
    return step1_objectSpread(step1_objectSpread({}, provided), {}, {
      color: "#333",
      borderRadius: 10,
      padding: "16px 24px",
      lineHeight: "26px",
      borderWidth: "0.5px",
      borderColor: "#007EFF !important",
      boxShadow: "none",
      fontWeight: "500",
      cursor: "pointer"
    });
  },
  valueContainer: function valueContainer(provided) {
    return step1_objectSpread(step1_objectSpread({}, provided), {}, {
      padding: 0,
      margin: 0
    });
  },
  menu: function menu(provided) {
    return step1_objectSpread(step1_objectSpread({}, provided), {}, {
      borderRadius: 10,
      overflow: "hidden"
    });
  },
  menuList: function menuList(provided) {
    return step1_objectSpread(step1_objectSpread({}, provided), {}, {
      padding: 0,
      overflowX: "hidden"
    });
  },
  option: function option(provided, state) {
    return step1_objectSpread(step1_objectSpread({}, provided), {}, {
      padding: "8px 16px",
      color: state.isSelected ? "#007eff" : "#333",
      background: state.isSelected || state.isFocused ? "#F1FBFF" : "",
      fontWeight: state.isSelected ? "600" : "normal",
      cursor: "pointer",
      margin: "2px 2px"
    });
  },
  placeholder: function placeholder(provided) {
    return step1_objectSpread(step1_objectSpread({}, provided), {}, {
      padding: 0,
      margin: 0,
      color: "#333"
    });
  },
  input: function input(provided) {
    return step1_objectSpread(step1_objectSpread({}, provided), {}, {
      padding: 0,
      margin: 0,
      lineHeight: "26px"
    });
  },
  indicatorSeparator: function indicatorSeparator(provided) {
    return step1_objectSpread(step1_objectSpread({}, provided), {}, {
      backgroundColor: "transparent"
    });
  },
  group: function group(provided) {
    return step1_objectSpread(step1_objectSpread({}, provided), {}, {
      backgroundColor: "transparent",
      padding: "0px 0px 0px 20px"
    });
  },
  groupHeading: function groupHeading(provided) {
    return step1_objectSpread(step1_objectSpread({}, provided), {}, {
      fontSize: "16px",
      color: "#007eff",
      position: "relative",
      left: "-16px",
      marginBottom: "0px"
    });
  }
};

function Step1(_ref) {
  var data = _ref.data;

  var _useContext = (0,react.useContext)(contexts/* GrantsAndIncentivesContext */.iz),
      setStep = _useContext.setStep,
      dataStep1 = _useContext.dataStep1,
      setDataStep1 = _useContext.setDataStep1;

  var needs_based = data.needs_based,
      industry = data.industry,
      business_stage = data.business_stage; // Because need_base return from api is a list single object not  hierarchical object list
  // So have to custom this to hierarchical list

  var customNeedsBase = function customNeedsBase() {
    var customData = (0,toConsumableArray/* default */.Z)(needs_based);

    var childrenObjectArr = customData.filter(function (item) {
      return item.parent_id;
    }); // Get item which have parent by parent_id in each item

    var options_list_filter = [];
    var options_list_can_select = []; // Custom data to react-select structure {option:abc, label:xyz}

    var _loop = function _loop(index) {
      var item = customData[index]; // Filter children which belong to item children by item.value
      // Item.value also children_parent_id

      var options_list = childrenObjectArr.filter(function (child) {
        return child.parent_id == item.value;
      }); // Push children list for remove from main data when return hierarchical object list

      options_list_filter = [].concat((0,toConsumableArray/* default */.Z)(options_list_filter), (0,toConsumableArray/* default */.Z)(options_list)); // Some parent can click and some parent can't
      // Push children options to item option if item is disabled. Item have is_disabled and option_list.length > 0.

      if (options_list.length > 0 && item.is_disabled === true) {
        item.options = options_list;
      } else if (options_list.length > 0 && item.is_disabled === false) {
        // Item is Parent and have children list but can select parent so push parent tu option_list_can_select
        options_list_can_select.push({
          label: item.label,
          options: options_list
        });
      }
    };

    for (var index = 0; index < customData.length; index++) {
      _loop(index);
    } // Remove parent can select from main data


    var _loop2 = function _loop2(_index) {
      var element = options_list_can_select[_index];
      var index_of_option = customData.findIndex(function (item) {
        var _item$label;

        return (item === null || item === void 0 ? void 0 : (_item$label = item.label) === null || _item$label === void 0 ? void 0 : _item$label.localeCompare(element.label)) === 0;
      });
      customData.splice(index_of_option + 1, 0, {
        options: element.options
      });
    };

    for (var _index = 0; _index < options_list_can_select.length; _index++) {
      _loop2(_index);
    }

    return (// Remove children contain in parent from main data
      customData.filter(function (item) {
        return options_list_filter.findIndex(function (option) {
          return option.value === item.value;
        }) < 0;
      }) || []
    );
  };

  var checkParentCanSelect = function checkParentCanSelect(el) {
    return el.is_disabled === false && el.parent_id === null && needs_based.filter(function (item) {
      return item.parent_id === el.value;
    }).length > 0;
  };

  var CustomOption = function CustomOption(props) {
    var data = props.data,
        innerRef = props.innerRef,
        innerProps = props.innerProps,
        isSelected = props.isSelected;
    return checkParentCanSelect(data) ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", step1_objectSpread(step1_objectSpread({
      ref: innerRef
    }, innerProps), {}, {
      className: "cursor-pointer px-4 py-2 font-medium  text-bbc-brand-500 hover:bg-bbc-brand-100 ".concat(isSelected ? "bg-bbc-brand-100" : ""),
      children: data.label
    })) : /*#__PURE__*/(0,jsx_runtime.jsx)(index_a86253bb_esm.c.Option, step1_objectSpread({}, props));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((Index_module_default()).step1, " relative z-30"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-8",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "".concat((Index_module_default()).title),
          children: "What types of activities are you looking to getting support?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
          defaultValue: dataStep1.needs_based_hold,
          options: (0,toConsumableArray/* default */.Z)(customNeedsBase()),
          isSearchable: true,
          inputMode: "search",
          placeholder: "Types...",
          styles: step1_customStyles,
          components: {
            IndicatorsContainer: function IndicatorsContainer() {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(IoChevronDown, {
                className: "cursor-pointer",
                size: 20
              });
            },
            Option: CustomOption
          },
          onChange: function onChange(value) {
            // If (checkParentCanSelect(value)) {
            //   SetDataStep1((prev) => ({
            //     ...prev,
            //     Needs_based: needs_based
            //       .filter((item) => item.parent_id === value.value)
            //       .map((item) => item.value),
            //   }));
            // } else {
            //   SetDataStep1((prev) => ({
            //     ...prev,
            //     Needs_based_hold: value,
            //     Needs_based: value.value,
            //   }));
            // }
            setDataStep1(function (prev) {
              return step1_objectSpread(step1_objectSpread({}, prev), {}, {
                needs_based_hold: value,
                needs_based: value.value
              });
            });
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-8",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "".concat((Index_module_default()).title),
          children: "What industry does your company conduct business in?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
          defaultValue: dataStep1.industry_hold,
          options: industry,
          isSearchable: true,
          inputMode: "search",
          placeholder: "Types...",
          styles: step1_customStyles,
          components: {
            IndicatorsContainer: function IndicatorsContainer() {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(IoChevronDown, {
                className: "cursor-pointer",
                size: 20
              });
            }
          },
          onChange: function onChange(value) {
            setDataStep1(function (prev) {
              return step1_objectSpread(step1_objectSpread({}, prev), {}, {
                industry_hold: value,
                industry: value.value
              });
            });
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-8",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "".concat((Index_module_default()).title),
          children: "How could you describe your business in terms of size?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
          defaultValue: dataStep1.business_stage_hold,
          options: business_stage,
          isSearchable: false // InputMode="search"
          ,
          placeholder: "Types...",
          styles: step1_customStyles,
          components: {
            IndicatorsContainer: function IndicatorsContainer() {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(IoChevronDown, {
                className: "cursor-pointer",
                size: 20
              });
            }
          },
          onChange: function onChange(value) {
            setDataStep1(function (prev) {
              return step1_objectSpread(step1_objectSpread({}, prev), {}, {
                business_stage_hold: value,
                business_stage: value.value
              });
            });
          }
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "text-right",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
        disabled: dataStep1 && Object.keys(dataStep1).length < 5,
        variant: "ghost",
        btnPadding: "px-0 py-0",
        btnColor: "bg-transparent",
        othersClass: (Index_module_default()).disabledBtn,
        onClick: function onClick() {
          setStep(function (prev) {
            return prev + 1;
          });
        },
        children: "Next"
      })
    })]
  });
}

/* harmony default export */ var step1 = (Step1);
;// CONCATENATED MODULE: ./components/templates/sg/guide-and-tool/singapore-grants-incentives/index.js












var dataStep = [{
  id: 1,
  name: "Grants & Incentives Qualifying",
  sub_step: []
}, {
  id: 2,
  name: "Company Information",
  sub_step: []
}, {
  id: 3,
  name: "Suggested Grants & Incentives",
  sub_step: []
}];

function GrantsAndIncentives(_ref) {
  var data = _ref.data;

  var _useState = (0,react.useState)(1),
      step = _useState[0],
      setStep = _useState[1];

  var _useState2 = (0,react.useState)(true),
      firstScreen = _useState2[0],
      setFirstScreen = _useState2[1];

  var _useState3 = (0,react.useState)({}),
      userData = _useState3[0],
      setUserData = _useState3[1];

  var _useState4 = (0,react.useState)({}),
      dataStep1 = _useState4[0],
      setDataStep1 = _useState4[1];

  var _useState5 = (0,react.useState)({}),
      dataStep2 = _useState5[0],
      setDataStep2 = _useState5[1];

  var reset = function reset() {
    setDataStep1({});
    setDataStep2({});
    setFirstScreen(false);
    setStep(1);
  };

  (0,react.useEffect)(function () {
    (0,hong_kong_cost_planning_tool/* scrollTop */.S)();
  }, [step]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(contexts/* GrantsAndIncentivesContext.Provider */.iz.Provider, {
    value: {
      step: step,
      setStep: setStep,
      firstScreen: firstScreen,
      setFirstScreen: setFirstScreen,
      userData: userData,
      setUserData: setUserData,
      dataStep1: dataStep1,
      setDataStep1: setDataStep1,
      dataStep2: dataStep2,
      setDataStep2: setDataStep2,
      reset: reset
    },
    children: firstScreen ? /*#__PURE__*/(0,jsx_runtime.jsx)(StartScreenGrantsIncentives, {}) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative bg-white lg:bg-transparent",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container-fluid md:container ",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((Index_module_default()).wrapper),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title/* default */.Z, {
            className: "mb-10 text-center text-bbc-30px font-semibold text-bbc-brand-700",
            children: ["Singapore", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Grants & Incentives"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mb-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(StepBar/* default */.Z, {
              step: step,
              data: dataStep
            })
          }), step === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(step1, {
            data: data.step1
          }), step === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)(step2, {
            data: data.step2
          }), step === 3 && /*#__PURE__*/(0,jsx_runtime.jsx)(Step3, {
            data: data.step3
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "absolute z-10  w-full bg-white lg:hidden",
        style: {
          height: "200px",
          bottom: "-200px"
        }
      })]
    })
  });
}

/* harmony default export */ var singapore_grants_incentives = (GrantsAndIncentives);
;// CONCATENATED MODULE: ./pages/sg/guide-and-tool/singapore-grants-and-incentives/index.js



var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "sg",
    navLight: true,
    page: data === null || data === void 0 ? void 0 : data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(singapore_grants_incentives, {
      data: data
    })
  });
}

/***/ }),

/***/ 38199:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sg/guide-and-tool/singapore-grants-and-incentives",
      function () {
        return __webpack_require__(81397);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56507:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subStepName":"Index_subStepName__LK5UP"};

/***/ }),

/***/ 64792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Index_wrapper__paFc2","title":"Index_title__3YXH4","companyName":"Index_companyName__9sIFN","step1":"Index_step1__6_loP","step2":"Index_step2__Wr4I9","step3":"Index_step3__6EUP0","disabledBtn":"Index_disabledBtn__k70Sf"};

/***/ }),

/***/ 33457:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Index_checkbox__xQNsP"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,9593,9885,9973,5955,9669,9131,4090,9738,2864,9774,2888,179], function() { return __webpack_exec__(38199); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);